<template>
  <div id="drag" class="drag-drop" :style="{ top: positionY + 'rem', left: positionX + 'rem' }" v-if="shows">
    <div class="live-top" @mousedown="move">
      <div>
        <img src="../../../images/live-label.png" alt="" />
        <span>正在直播</span>
      </div>
      <b-icon icon="x" font-scale="1.5" color="#B4B4B4" @click="closeShow"></b-icon>
    </div>
    <div class="list-content" @click="goToLive">
      <div class="lc-left"><img :src="liveAll.cover" alt="" /></div>
      <div class="lc-right">
        <div class="lc-title">{{ liveAll.title }}</div>
        <div>
          <div class="lc-teacher">老师:{{ liveAll.teacher_name }}</div>
          <div class="lc-time">
            <span class="time-start">
              <span class="time-text">已开始:</span>
              {{ liveTime }}
            </span>
          </div>
        </div>
      </div>
    </div>
     <tips :isShow='remindShow' @close='closeShows' @determine='join'></tips>
  </div>
</template>

<script>
import { had_begin, rtm_token_web } from '@/api/mycenter.js'
import tips from './live_tip.vue'
export default {
  components: {
    tips
  },
  name: 'DragDrop',
  props: {
    positionX: {
      type: String,
      required: true
    },
    positionY: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      shows: false, // 是否显示
      liveAll: '', // 直播接口
      liveTime: '', // 直播时间
      nowTime: '', // 当前时间
      remindShow: false,
      joinLiving: ''
    }
  },

  created () {
    this.liveIng()
  },
  methods: {
    join () {
      console.log('我是进入直播')
      console.log('userUuid',this.$store.state.live_id)
      console.log('userName',this.$store.state.name)
      this.remindShow = false
      rtm_token_web(this.joinLiving)
        .then(response => {
          window.open(
            'https://ielts.honeybee-edu.com/dist/living.html?' +
              'rtmToken=' +
              encodeURIComponent(response.data) +
              '&userUuid=' +
              this.$store.state.live_id +
              '&userName=' +
              this.$store.state.name +
              '&roomUuid=' +
              this.joinLiving.roomUuid +
              '&roomName=' +
              this.joinLiving.roomName +
              '&duration=' +
             this.joinLiving.duration +
              '&roleType=' +
              2,
            '_blank'
          )
        })
        .catch(error => {
          console.log(error)
        })
    },
    closeShows (e) {
      this.remindShow = false
    },
    timers (_time) {
      let that = this
      var timeStutes = _time
      this.timer = setInterval(() => {
        let timestamp = new Date(timeStutes.replace(/-/g, '/')).getTime()
        this.nowTime = Date.parse(new Date())
        let time = this.nowTime - timestamp
        let hrs, mins, secs
        let hr = parseInt((time / 1000 / 60 / 60) % 24)
        let min = parseInt((time / 1000 / 60) % 60)
        let sec = parseInt((time / 1000) % 60)
        hrs = hr > 9 ? hr : '0' + hr
        mins = min > 9 ? min : '0' + min
        secs = sec > 9 ? sec : '0' + sec
        that.liveTime = hrs + ':' + mins + ':' + secs
      }, 1000)
    },
    liveIng () {
      // 我的直播课
      had_begin()
        .then(response => {
          console.log(response)
          if (response.data) {
            this.liveAll = response.data
            this.timers(this.liveAll.updated_at)
            this.shows = true
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    goToLive () {
      // 跳转直播
      this.joinLiving = {
        userUuid: this.$store.state.live_id,
        userName: this.$store.state.name,
        roomUuid: this.liveAll.res_id,
        roomName: this.liveAll.title,
        duration: parseFloat(this.liveAll.max_duration) * 3600,
        id: this.liveAll.id,
        roleType: 2
      }
      if ((localStorage.getItem('livtips')) == 2) {
        this.join()
      } else {
        console.log(localStorage.getItem('livtips'))
        this.remindShow = true
      }
    },
    closeShow () {
      // 关闭显示
      this.shows = false
    },
    move (e) {
      let odiv = document.getElementById('drag') // 获取目标元素
      // console.log(e)
      // 算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft
      let disY = e.clientY - odiv.offsetTop
      document.onmousemove = e => {
        // 鼠标按下并移动的事件
        // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX
        let top = e.clientY - disY
        // 移动当前元素
        odiv.style.left = left + 'px'
        odiv.style.top = top + 'px'
      }
      document.onmouseup = e => {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}
</script>

<style scoped="scoped" lang="scss">
.drag-drop {
  position: absolute;
  width: 12rem;
  background: #ffffff;
  box-shadow: 0rem 0rem 0rem #eeeeee;
  border-radius: 1rem;
  .live-top {
    display: flex;
    align-items: center;
    height: 1.8rem;
    border-bottom: 1px solid #f1f1f1;
    justify-content: space-between;
    padding-right: 0.3rem;
    cursor: move;
    img {
      width: 0.72rem;
      height: 0.72rem;
      margin: 0 0.3rem 0 0.8rem;
    }
    span {
      font-size: 0.65rem;
      color: #fd9800;
    }
  }
  .list-content {
    padding: 0.8rem 0.7rem;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    .lc-left {
      img {
        width: 4.2rem;
        height: 5.5rem;
        object-fit: cover;
      }
    }
    .lc-right {
      width: calc(100% - 5rem);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      text-align: left;
      .lc-title {
        font-size: 0.8rem;
        font-weight: bold;
        color: #363636;
      }
      .lc-teacher,
      .lc-time {
        font-size: 0.65rem;
        color: #b4b4b4;
        margin-top: 0.2rem;
        width: 100%;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        .time-text {
          color: #b4b4b4;
        }
      }
      .lc-time {
        span {
          color: #fd9800;
        }
        .time-start {
          color: #2cd575;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter/component/drag_drop.vue